let prism = false
const listeners = new Set<() => void>()

export function setMemoryBackend(backend: "prism" | undefined): void {
  const next = backend === "prism"
  if (next === prism) return
  prism = next
  listeners.forEach((listener) => listener())
}

export function prismMemorySnapshot(): boolean {
  return prism
}

export function subscribeMemoryBackend(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
